import React from 'react';
import { Icon } from '@types';

export const WarningQld = ({ customStyles, handleClick }: Icon) => {
	return (
		<svg
			className={customStyles}
			onClick={handleClick}
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			fill="none"
			viewBox="0 0 20 20"
		>
			<circle cx="10" cy="10" r="8" fill="#E22339"></circle>
			<path
				fill="#fff"
				d="M10 13c-.583 0-1 .536-1 1 0 .5.417 1 1 1 .542 0 1-.5 1-1 0-.464-.458-1-1-1zm0-1c.804 0 1-.679 1-1V6c0-.5-.5-1-1-1s-1 .5-1 1v5c0 .321.196 1 1 1z"
			></path>
		</svg>
	);
};
